<section class="tag_line" [id]="tag.displayName">
  <div class="name"><span>{{ tag.displayName }}</span></div>
  <div class="lastDatetime"> <span>{{ tag?.lastValues?.lastValueDatetime ? tag.lastValues.lastValueDatetime : '--' }}</span></div>
  <div class="lastValueTag"> <span>{{ tag?.lastValues?.lastValue ? tag.lastValues.lastValue : '--'}}</span></div>
  <div class="unit"> <span>{{ tag.unit ? tag.unit : '--' }}</span></div>
  @if (!display) {
    <div class="highThreshold"> <span>{{ tag.highThreshold ? tag.highThreshold : '--' }}</span></div>
  }
  @if (!display) {
    <div class="lowThreshold"> <span>{{ tag.highThreshold ? tag.highThreshold : '--' }}</span></div>
  }
  <div class="valueType">
    <span>{{ tag.valueType ? ('graphs.tag.value_type.' + tag.valueType | translate) : '--' }}</span>
  </div>
  <div class="group-cell__action {{tag.uid}}" [attr.data-id]="tag.unit">
    <a href="javascript:void(0)" (click)="onEventOnClick(tag)">
      <i class="far fa-square unchecked-icon"></i>
      <i class="fas fa-check-square checked-icon"></i>
    </a>
  </div>
</section>